/**
 * Nombres de plantilla que el Worker puede inyectar (subset usado en el cliente).
 *
 * Política home (2026-08):
 *   - DEFAULT + todos los ISO → `BaseTemplate` (site-settings / BaseTemplateAdmin)
 *   - Lock editorial → UI BaseTemplateBlack sin CTA
 *   - DualCTAVideoLanding solo override admin por país
 *
 * `DualCTAVideoLanding` es self-contained: no usa `isBaseTemplateFamily`.
 */

/** Template de home que inyecta el Worker para cualquier país (mapa + default). */
export const WORKER_HOME_TEMPLATE = "BaseTemplate" as const;

const BASE_TEMPLATE_FAMILY = new Set([
  "BaseTemplate",
  "BaseTemplateBlack",
  // Override por país (CountryTemplateAdmin): home editorial intl. Comparte la
  // familia Base (hero CTA por flags geo / site-settings, no el par dual).
  "BaseTemplateInternational",
]);

export function isBaseTemplateFamily(templateName: string | null | undefined): boolean {
  return !!templateName && BASE_TEMPLATE_FAMILY.has(templateName);
}
